import React from 'react';
import { useIntl } from 'react-intl';
import { DatedEvidence, EmptyComponent, Evidence } from '@eas/common-web';
import { MethodOD } from '@models';
import { EvidenceApiUrl, Permission } from '@enums';
import { useEvidencePermission } from '@utils';
import { useColumns } from './method-od-columns';
import { Fields } from './method-od-fields';
import { useValidationSchema } from './method-od-schema';

export function MethodODEvidence() {
  const intl = useIntl();
  const validationSchema = useValidationSchema();
  const columns = useColumns();

  const btnPermissions = useEvidencePermission({
    options: {
      NEW: [Permission.METHOD_OD_WRITE],
      EDIT: [Permission.METHOD_OD_WRITE],
      REMOVE: [Permission.METHOD_OD_WRITE],
    },
  });

  const evidence = DatedEvidence.useDatedEvidence<MethodOD>({
    version: 1,
    identifier: 'METHOD_OD',
    apiProps: {
      url: EvidenceApiUrl.METHOD_OD,
    },
    tableProps: {
      columns,
      tableName: intl.formatMessage({
        id: 'ZSD__METHOD_OD__TABLE__TITLE',
        defaultMessage: 'Spôsob OD',
      }),
      showBulkActionButton: false,
      showReportButton: false,
      defaultSorts: [],
    },
    detailProps: {
      toolbarProps: {
        title: intl.formatMessage({
          id: 'ZSD__METHOD_OD__DETAIL__TITLE',
          defaultMessage: 'Spôsob OD',
        }),
        subtitle: (type) => type?.name ?? '',
        showBtn: btnPermissions,
      },
      GeneralFieldsComponent: EmptyComponent,
      FieldsComponent: Fields,
      initNewItem: () => ({ active: true } as MethodOD),
      validationSchema,
    },
  });

  return <Evidence {...evidence} />;
}
